export default "__VITE_ASSET__f81db173__"